module.exports = "https://cdn.realtymogul.com/static/media/img_panel_income.62febff4.jpg";